module.exports = __webpack_public_path__ + "static/diversityprojectlogo-a198db6b31c9a33aebcae8419c6609bb.png";